var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7235 12.1625L11.4662 10.1991C12.4978 8.87192 13.0274 7.22298 12.9615 5.54331V4.84615H12.9415C13.3795 4.49877 13.6405 3.97472 13.6538 3.41585C13.6538 1.59785 10.868 0.646616 8.11538 0.646616C5.36277 0.646616 2.57692 1.59785 2.57692 3.41585C2.5903 3.97472 2.85131 4.49877 3.28931 4.84615H3.26923V5.54331C3.20335 7.22298 3.73297 8.87192 4.76462 10.1991L1.51077 12.1625C0.884128 12.5383 0.500479 13.2152 0.5 13.9458V16.6202C0.5 17.0026 0.809957 17.3125 1.19231 17.3125H7.42308V14.5433C7.42308 14.161 7.73303 13.851 8.11538 13.851C8.49774 13.851 8.80769 14.161 8.80769 14.5433V17.3125H15.0385C15.4208 17.3125 15.7308 17.0026 15.7308 16.6202V13.9424C15.7289 13.2139 15.347 12.5392 14.7235 12.1625ZM8.11539 2.07692C8.88009 2.07692 9.5 2.69684 9.5 3.46154C9.5 4.22624 8.88009 4.84615 8.11539 4.84615C7.35068 4.84615 6.73077 4.22624 6.73077 3.46154C6.73077 2.69684 7.35068 2.07692 8.11539 2.07692ZM8.11538 10.3895C6.09592 10.3895 4.68223 8.43162 4.65385 5.62015C5.76609 6.00822 6.93747 6.19939 8.11538 6.18508C9.29329 6.19939 10.4647 6.00822 11.5769 5.62015C11.5485 8.43162 10.1348 10.3895 8.11538 10.3895Z",
    fill: "#3290EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.8cfeaac9fece4ad328c0926d784e414d.svg";
export { ForwardRef as ReactComponent };